(function () {
    'use strict';

    angular
        .module('franchisee.components')
        .controller('PeopleFormController', PeopleFormController)

    /** @ngInject */
    function PeopleFormController($filter, $q, $scope, $rootScope, $state, $stateParams, HelperService, PersonService, AuthenticationService, sweetAlert, ResponsabilityService, ApiService, DEFAULT_IDENTIFIERS, DATA_EVENTS) {
        const vm = this;
        const personId = $stateParams.personId;
        let allResponsabilities;
        let apiControllers;

        let personOriginalData;
        let customPermissionOriginalData;

        // SYSTEM DEFAULT METHODS
        // vm.uiCanExit = () => {
        //     return HelperService.uiCanExit([
        //         personOriginalData,
        //         customPermissionOriginalData
        //     ], [
        //             vm.personData.Person_Unit,
        //             vm.customPermissions
        //         ]);
        // }

        // vm.isRelationshipDataModified = () => {
        //     return !vm.personData || !angular.equals(vm.personData.Person_Unit, personOriginalData);
        // }

        // vm.resetRelationshipForm = () => {
        //     angular.copy(personOriginalData, vm.personData.Person_Unit);
        // }

        // vm.isCustomPermissionDataModified = () => {
        //     return !angular.equals(vm.customPermissions, customPermissionOriginalData);
        // }

        // vm.resetCustomPermissionForm = () => {
        //     angular.copy(customPermissionOriginalData, vm.customPermissions);
        // }

        // ÁREA CUSTOM METHODS
        // Person Data
        vm.saveUserAssociations = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Essa ação irá alterar a associação da pessoa com as permissões selecionadas!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value)
                    saveUserAssociations(vm.personData.Person_Unit);
            })
        }

        vm.removeAssociation = personUnit => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Você irá remover a associação da pessoa com essa loja, ela não poderá mais visualizar os dados!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    let personUnitOriginal = vm.personData.Person_Unit;

                    vm.personData.Person_Unit = vm.personData.Person_Unit.filter(pu => (pu.UnitId != personUnit.UnitId));

                    personUnitOriginal.forEach(pu => {
                        if (pu.Id == personUnit.Id)
                            pu.Active = false;
                    })

                    $scope.$apply();

                    saveUserAssociations(personUnitOriginal);

                    init();
                }
            })
        }

        vm.isLoggedPersonCurrentUnit = unitId => {
            return ($rootScope.canUserEdit || $rootScope.canUserCreate) 
            // && (unitId == vm.loggedUserData.UnitId)
        }

        vm.getResponsabilities = unit => {
            if (!unit.HeadUnitId)
                return allResponsabilities.filter(resp => (resp.Id != 4));

            return allResponsabilities;
        }

        vm.changeTab = tabId => {
            vm.selectedTab = tabId;
        }

        // Person Custom Permissions
        vm.savePermissions = () => {
            HelperService.startLoading('.loading-holder');

            let permissionData = vm.customPermissions.filter(perm => (perm.IsGet != null));

            ApiService
                .saveCustomPermissions(permissionData, vm.selectedPersonUnit.Id)
                .then(
                    () => {
                        angular.copy(vm.customPermissions, customPermissionOriginalData);

                        HelperService.stopLoading('.loading-holder');
                        HelperService.successCallback();
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.loading-holder');
                    })
        }

        vm.onChangeSelectedPersonUnit = () => {
            let personCustomPermissions = [];
            let currentPersonCustomPermissions = vm.selectedPersonUnit.ApiController_Person_Unit;

            for (let index = 0; index < apiControllers.length; index++) {
                const apiController = apiControllers[index];

                const currentPersonControllerPermission = currentPersonCustomPermissions.find(perm => (perm.ApiControllerId == apiController.Id));

                if (currentPersonControllerPermission) {
                    currentPersonControllerPermission.ApiController = apiController;
                    currentPersonControllerPermission.IsRecord = currentPersonControllerPermission.IsPost;
                    currentPersonControllerPermission.ChangedByPersonId = vm.loggedUserData.PersonId;

                    personCustomPermissions.push(currentPersonControllerPermission);
                } else {
                    personCustomPermissions.push({
                        ApiControllerId: apiController.Id,
                        Person_UnitId: vm.selectedPersonUnit.Id,
                        ApiController: apiController,
                        IsGet: null,
                        IsPost: null,
                        IsPut: null,
                        IsRecord: null,
                        IsDelete: null,
                        ChangedByPersonId: vm.loggedUserData.PersonId
                    })
                }
            }

            vm.customPermissions = personCustomPermissions;

            customPermissionOriginalData = angular.copy(vm.customPermissions);
        }

        vm.onChangeRecordPermission = permission => {
            permission.IsPost = permission.IsRecord;
            permission.IsPut = permission.IsRecord;
        }

        vm.isPermissionRequired = customPermission => {
            if (customPermission.IsGet != null || customPermission.IsRecord != null || customPermission.IsDelete != null)
                return true;

            return false;
        }

        vm.onCheckAll = () => {
            for (let index = 0; index < vm.customPermissions.length; index++) {
                const module = vm.customPermissions[index];

                module.IsGet = vm.getAll;
                module.IsRecord = vm.getAll;
                module.IsPost = vm.getAll;
                module.IsPut = vm.getAll;
                module.IsDelete = vm.getAll;
            }
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            $state.go('app.people-list');
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function saveUserAssociations(personUnitData) {
            HelperService.startLoading('.loading-holder');

            let personUnitFinal = personUnitData
                .filter(personDataUnit => (vm.isLoggedPersonCurrentUnit(personDataUnit.UnitId)))
                .reduce((acc, cur) => {
                    let associationData = {
                        UnitId: cur.UnitId,
                        PersonId: vm.personData.Id,
                        ResponsibilityId: cur.ResponsibilityId,
                        Active: cur.Active,
                        Id: cur.Id,
                        AccessLevelId: DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE_WORKER
                    };

                    acc.push(associationData);

                    return acc;
                }, []);

            PersonService
                .updateUnitAssociation(personUnitFinal)
                .then(() => {
                    angular.copy(vm.personData.Person_Unit, personOriginalData);

                    HelperService.successCallback('update');
                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                })
        }

        function getPerson() {
            if (!personId) {
                sweetAlert.swal({
                    title: 'Não foi possível recuperar os dados da pessoa!',
                    text: 'Ocorreu um erro ao buscar o identificador da pessoa',
                    type: 'warning',
                    confirmButtonText: 'Ir para Home',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value) {
                        HelperService.stopLoading('.loading-holder');

                        $state.go('app.home');
                    }
                })

                return;
            }

            PersonService
                .get(personId)
                .then(success => {
                    if (success.RegistrationDate)
                        success.FormattedRegistrationDate = moment(success.RegistrationDate).format('DD/MM/YYYY HH:mm:ss');
                    else
                        success.FormattedRegistrationDate = '-';

                    if (success.Birthdate)
                        success.FormattedBirthdate = moment(success.Birthdate).format('DD/MM/YYYY HH:mm:ss');
                    else
                        success.FormattedBirthdate = '-';

                    vm.personData = success;
                    vm.loggedUserUnits = AuthenticationService.getUnits(); 

                    // Show the franchiser only his current unit on user association units
                    if (vm.personData.Person_Unit)
                        vm.personData.Person_Unit = vm.personData.Person_Unit.filter(personUnit => vm.loggedUserUnits.some(x => x.Id == personUnit.UnitId));
                   
                    if (vm.personData.Person_Image.length) {
                        let personMainImage = vm.personData.Person_Image.find(image => (image.Main));

                        if (personMainImage) {
                            vm.mainImageData.image = personMainImage.Url;
                            vm.mainImageData.display = HelperService.imageResizePath('person', vm.personData.Id, personMainImage.Url, 150, 150);
                        }
                    }

                    personOriginalData = angular.copy(vm.personData.Person_Unit);

                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.stopLoading('.loading-holder');
                    HelperService.errorCallback(error);
                })
        }

        function getResponsabilities() {
            return ResponsabilityService
                .getAll()
                .then(success => {
                    allResponsabilities = success.filter(resp => (resp.Id != 4));
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.unit-permission-listing');
                })
        }

        function getControllers() {
            return ApiService
                .getControllers()
                .then(success => {
                    success = success.filter(ctrl => {
                        if (ctrl.Id == 21) {
                            ctrl.Description = 'Pessoas';
                            return ctrl;
                        } else if (ctrl.Id == 25) {
                            ctrl.Description = 'Loja';
                            return ctrl;
                        }
                    });

                    apiControllers = $filter('orderBy')(success, 'Id', false);
                }, error => {
                    HelperService.stopLoading('.loading-holder');
                    HelperService.errorCallback(error);
                })
        }

        function initVars() {
            vm.loggedUserData = AuthenticationService.getSelectedData();

            if (personId == vm.loggedUserData.PersonId) {
                $state.go('app.my-profile');
                return;
            }

            vm.selectedTab = 1;
            vm.selectOptions = [{
                Value: true,
                Description: 'SIM'
            }, {
                Value: false,
                Description: 'NÃO'
            }];
            vm.getAll = null;

            vm.mainImageData = {
                display: '',
                image: ''
            }
        }

        function init() {
            initVars();

            HelperService.startLoading('.loading-holder');

            $q.all([getControllers(), getResponsabilities()])
                .then(() => {
                    getPerson();
                })
        }
    }
}());